import React from 'react';
import './bio.css'
import Imagen1 from '../../images/bio/7F5A6823.jpg'
import Imagen2 from '../../images/bio/STLDUO1_ZIPPO.jpg'
import { Fade } from "react-awesome-reveal";

function Bio() {
    return (
        <section className='biowrapper' id='bio'>
            <div className='parte1'>
                <div className='biofoto1'>
                    <Fade duration={1500} delay={100} fraction={0.2}>
                        <img src={Imagen1} className='img1es' alt="" />
                    </Fade>
                </div>
                <div className='biotexto'>
                    <Fade duration={1500} delay={100} fraction={0.3}>
                        <h2>IRMGARD AMY MÜNCHGESANG</h2>
                    </Fade>
                    <Fade duration={1500} delay={100} fraction={0.3}>
                        <p>
                Violist and Singer
She specialized in tango music at the Orquesta Escuela Municipal de Tango (Rosario) by Javier
Martínez Lo Re and was a member of renowned ensembles such as Conjunto Sextango by Omar
Torres, Orquesta Carlos Quilici, and the Orquesta de Señoritas. With several of these groups, she toured
Europe, performing both as a musician and a producer.In addition to her work as a performer, she has
also worked as an arranger, composer, and session musician, collaborating on projects spanning various
musical genres within the Argentine music scene.She is a feminist activist and a member of the
Colectivo de Mujeres Tangueras Rosario, advocating for greater gender equality in tango.Currently, she
is a violist with the Orquesta Sinfónica Provincial de Rosario and teaches in various institutions. She is
currently working on her first solo album.
                </p>
                <br />
                <p className='photographer'>Photo by Eriola Postoli</p>
                    </Fade>
                </div>
            </div>
            <div className="parte2">
                
                <div className='biotexto'>
                <Fade bottom duration={1500} delay={100} fraction={0.3}>
                <p>
            Born in Germany and based in Argentina, she began her viola studies in Germany and later completed
her training in Nijmegen (Netherlands). She holds a degree in Music Therapy

                    </p>
                    <br />
                    <p className='photographer'>Photo by Zippo Zimmermann</p>
                </Fade>

                </div>
                <div className='biofoto2'>
                    <Fade duration={1500} delay={100} fraction={0.2}>
                        <img src={Imagen2} className='img2es' alt="" />

                    </Fade>
                </div>
            </div>
        </section>
    )
}

export default Bio